import React, { useEffect, useState } from 'react';

import { IconStatus } from '../../../../typings/design-tokens';
import IconMediaPlay from '../../icons/icon-media-play';
import styles from '../../../../utils/styles';
import { TypographyElements } from '../../../foundation';

import './Button.scss';

export interface IButton {
  status?: IconStatus;
  className?: string;
}

const Button: React.FC<IButton> = ({ status = 'normal', className }) => {
  const [changeStatus, setChangeStatus] = useState(status);

  useEffect(() => {
    setChangeStatus(status);
  }, [status]);

  return (
    <div className={styles('button', status !== 'disabled' && 'button--pointer', className)}>
      <IconMediaPlay size="small" color="light" status={changeStatus} />

      <TypographyElements text="PLAY" typographyClass="ty-elements-medium--uppercase" className={['button__text']} />
    </div>
  );
};

export default Button;
